// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3aRpF","gfeWrapper":"CalendarEvent_gfeWrapper__17mzo"};